import * as Yup from 'yup'

export const makeValidationSchema = () =>
  Yup.object({
    name: Yup.string()
      .min(3, 'O nome do produto deve ter pelo menos 3 caracteres')
      .required('Nome do produto é obrigatório'),
  })
